module.exports = __webpack_public_path__ + "img/organigramme.655c5bd1.png";